module.exports = __webpack_public_path__ + "static/media/fnt.1e1bf115.jpg";